import { PageVisibility, FetchLoader } from 'xgplayer-helper-utils'
import { FlvDemuxer, Mp4Remuxer as Remuxer } from 'xgplayer-helper-transmuxers'
import { Buffer as XgBuffer, Tracks, XGDataView, RemuxedBufferManager } from 'xgplayer-helper-models'

class Logger {
  warn () {}
}

export const CORE_EVENT = {
  LOADRETRY: 'retry',
  TTFB: 'ttfb',
  METADATA: 'metadataparsed',
  KEYFRAME: 'isKeyframe',
  SEI: 'SEI_PARSED'

}

export default {
  PageVisibility,
  FlvDemuxer,
  FetchLoader,
  Tracks,
  XgBuffer,
  Logger,
  Remuxer,
  RemuxedBufferManager,
  XGDataView
}
